module.exports = __webpack_public_path__ + "static/media/20210411_164716_152_IMG_0532.55dff6c1.jpg";